// extracted by mini-css-extract-plugin
export default {"moreCont":"More_moreCont__AC99G","moreText":"More_moreText__ZxMJp"};